import React, { useState } from 'react'
import { Box } from '../../../../../../../Components/CustomUi/box'
import Input from '../../../../../../../Components/CustomUi/input'
import { Select } from '../../../../../../../Components/CustomUi/Select'
import {
  faBacteria,
  faBacterium,
  faBalanceScale,
  faCaretUp,
  faCheck,
  faDna,
  faListDots,
  faListNumeric,
  faPen,
  faPercentage,
  faPlus,
  faWeight,
} from '@fortawesome/free-solid-svg-icons'
import ButtonCustom from '../../../../../../../Components/ButtonCustom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { HeaderTable } from '../../../../../../../Components/CustomUi/table/headerTable'
import { BodyTable } from '../../../../../../../Components/CustomUi/table/bodyTable'
import { Render } from '../../../../../../../Components/CustomUi/render'
import { RowTable } from '../../../../../../../Components/CustomUi/table/rowTable'
import { RowItem } from '../../../../../../../Components/CustomUi/table/rowItem'
import { DeleteButton } from '../../../../../../../Components/CustomUi/deleteButton'
import { Empty } from 'antd'
import TextArea from '../../../../../../../Components/CustomUi/textarea'
import Icone from '../../../../../../../assets/svg/lupa.svg'
import Carregando from '../../../../../../../Components/CustomUi/loading'
import { apenasNumeros, apenasNumerosDecimais } from '../../../../../../../utils'

interface PropsComposicao {
  microrganismo_selecionado: string
  setMicrorganismo_selecionado: React.Dispatch<React.SetStateAction<string>>
  setMicrorganismo_selecionado_id: React.Dispatch<React.SetStateAction<number>>
  valor: string
  setValor: React.Dispatch<React.SetStateAction<string>>
  expoente: string
  setExpoente: React.Dispatch<React.SetStateAction<string>>
  porcentagem: string
  setPorcentagem: React.Dispatch<React.SetStateAction<string>>
  tipo_porcentagem: string
  setTipo_porcentagem: React.Dispatch<React.SetStateAction<string>>
  setTipo_porcentagem_id: React.Dispatch<React.SetStateAction<number>>
  concentracao: string
  setConcentracao: React.Dispatch<React.SetStateAction<string>>
  cepa: string
  setCepa: React.Dispatch<React.SetStateAction<string>>
  densidade: string
  setDensidade: React.Dispatch<React.SetStateAction<string>>
  confirmar_exclusao: boolean
  setConfirmar_exclusao: React.Dispatch<React.SetStateAction<boolean>>
  id_item_atual: number
  setId_item_atual: React.Dispatch<React.SetStateAction<number>>
  setNome_item_atual: React.Dispatch<React.SetStateAction<string>>
  fake_loading: boolean
  editar_concentracao: number
  data_microrganismos: any[]
  composicao_adicionada: any[]
  adicionarComposicao: Function
  editarComposicao: Function
  salvarComposicao: Function
  mudarConcentracao: Function
  remover_microrganismos: Function
  loadingComposicao: boolean
  formulacao: string
}

export const Composicao: React.FC<PropsComposicao> = ({
  microrganismo_selecionado,
  setMicrorganismo_selecionado,
  setMicrorganismo_selecionado_id,
  valor,
  setValor,
  expoente,
  setExpoente,
  concentracao,
  setConcentracao,
  porcentagem,
  setPorcentagem,
  tipo_porcentagem,
  setTipo_porcentagem,
  setTipo_porcentagem_id,
  cepa,
  setCepa,
  densidade,
  setDensidade,
  confirmar_exclusao,
  setConfirmar_exclusao,
  setNome_item_atual,
  id_item_atual,
  setId_item_atual,
  fake_loading,
  editar_concentracao,
  data_microrganismos,
  composicao_adicionada,
  adicionarComposicao,
  editarComposicao,
  salvarComposicao,
  mudarConcentracao,
  remover_microrganismos,
  loadingComposicao,
  formulacao,
}) => {
  const [open, setOpen] = useState<boolean>(false)
  const [openTipo, setOpenTipo] = useState<boolean>(false)

  const dataPorcentagem = [
    { cod: 1, nome: 'm/m' },
    { cod: 2, nome: 'm/v' },
  ]

  function calculo(valor, expoente) {
    const valorFormatado = String(valor).replace(',', '.')
    const resultado = parseFloat(valorFormatado) * 10 ** Number(expoente)
    setConcentracao(
      isNaN(resultado) ? '0' : resultado.toLocaleString('pt-BR', { maximumFractionDigits: 20 })
    )
    return isNaN(resultado) ? '0' : resultado.toLocaleString('pt-BR', { maximumFractionDigits: 20 })
  }

  function mascaraDecimal(data) {
    let area = data.replace(/\D/g, '')
    area = area.replace(/([\u0300-\u036f]|[^0-9a-zA-Z\s])/g, '')
    area = (area / 100).toFixed(2).replace('.', ',')

    setDensidade(area)
  }

  return (
    <div>
      <Box gap={5}>
        <div style={{ display: 'flex', gap: '10px' }}>
          <Select
            label='Microrganismo'
            placeholder='Selecionar microrganismos'
            icon={faBacterium}
            value={microrganismo_selecionado}
            onChange={setMicrorganismo_selecionado}
            onChangeID={setMicrorganismo_selecionado_id}
            open={open}
            trigger={setOpen}
            items={data_microrganismos}
            descricaoItem={'nome_cientifico'}
            idItem={'cod'}
          />
        </div>
        <TextArea
          label='Cepa'
          placeholder='Digite a cepa'
          value={cepa}
          onChange={setCepa}
          maxHeight={80}
        />
        <div style={{ display: 'flex', gap: '10px' }}>
          <Input
            label='Porcentagem microrganismo no produto'
            placeholder='Digite a porcentagem'
            value={apenasNumerosDecimais(porcentagem)}
            onChange={setPorcentagem}
            icon={faPercentage}
          />

          <Select
            label='Tipo porcentagem'
            placeholder='Selecione o tipo da porcentagem'
            value={tipo_porcentagem}
            onChange={setTipo_porcentagem}
            onChangeID={setTipo_porcentagem_id}
            open={openTipo}
            trigger={setOpenTipo}
            items={dataPorcentagem}
            descricaoItem={'nome'}
            idItem={'cod'}
            icon={faListDots}
            disabled={['Sólido', 'Turfosa', 'Liofilizada'].includes(formulacao)}
          />
        </div>
        <Render condition={['Gel', 'Líquida'].includes(formulacao) && tipo_porcentagem === 'm/m'}>
          <Input
            label='Densidade'
            placeholder='Digite a densidade'
            icon={faWeight}
            value={apenasNumerosDecimais(densidade)}
            onChange={(e) => mascaraDecimal(e)}
          />
        </Render>

        <div>
          <label
            style={{
              fontSize: '13px',
              fontWeight: 500,
              display: 'inline-flex',
              marginBottom: '3px',
            }}
          >
            Concentração
          </label>
          <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
            <Input
              placeholder='0'
              icon={Icone}
              value={apenasNumerosDecimais(valor)}
              onChange={setValor}
              width={'15%'}
              allowClear={false}
            />
            <div>
              <span style={{ opacity: '0.3', fontWeight: 600 }}>x 10</span>
            </div>
            <Input
              placeholder='0'
              icon={faCaretUp}
              value={apenasNumeros(expoente)}
              onChange={setExpoente}
              width={'15%'}
              allowClear={false}
            />
            <span style={{ opacity: '0.3', fontWeight: 600 }}>=</span>
            <div style={{ width: '60%', display: 'flex', alignItems: 'end', gap: '5px' }}>
              <span style={{ opacity: '0.5', fontWeight: 600 }}>{calculo(valor, expoente)}</span>{' '}
              <p style={{ margin: '0px', padding: '0px', fontSize: '11px', opacity: '0.5' }}>
                de UFC´s
              </p>
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <ButtonCustom
            onClick={() =>
              editar_concentracao > 0
                ? salvarComposicao(editar_concentracao)
                : adicionarComposicao()
            }
            icon={<FontAwesomeIcon icon={editar_concentracao > 0 ? faCheck : faPlus} />}
          >
            {editar_concentracao > 0 ? 'Atualizar' : 'Inserir'}
          </ButtonCustom>
        </div>
      </Box>
      <HeaderTable
        itens={[
          { valor: 'Microrganismo', width: 'calc(100% - 500px)' },
          { valor: 'Concentração', width: '160px' },
          { valor: 'Porcentagem', width: '120px' },
          { valor: 'Cepa', width: '100px' },
          { valor: 'Ações', width: '115px' },
        ]}
      />

      <BodyTable
        style={{
          height: 'calc(100vh - 350px)',
          position: 'relative',
          overflowX: 'hidden',
          overflowY: 'scroll',
          marginTop: -10,
        }}
      >
        <Render condition={loadingComposicao === false}>
          {(composicao_adicionada ?? []).map(
           
            (
              
              {
                cod,
                uid,
                microrganismo_nome,
                cod_microrganismo,
                concentracao,
                tipo_porcentagem_nome,
                tipo_porcentagem,
                porcentagem,
                densidade,
                cepa,
              },
              index
            ) => {
               console.log('CEPA', cepa)
              return (
                <RowTable
                  key={cod}
                  onDoubleClick={() => { }}
                  style={{
                    marginTop: index === 0 ? '10px' : 0,
                    backgroundColor:
                      editar_concentracao === cod && editar_concentracao !== null ? '#c9f8d8' : '',
                  }}
                >
                  <RowItem fontSize={13} width={'calc(100% - 495px)'}>
                    {microrganismo_nome}
                  </RowItem>
                  <RowItem fontSize={12} width={'160px'}>
                    {concentracao}
                  </RowItem>

                  <RowItem fontSize={12} width={'120px'}>
                    {`${Number(porcentagem)?.toFixed(2)} %`}
                  </RowItem>

                  <RowItem fontSize={12} width={'100px'}>
                    {cepa}
                  </RowItem>

                  <RowItem width={'115px'} gap={10}>
                    <DeleteButton
                      open={confirmar_exclusao && id_item_atual === (uid ?? cod)}
                      trigger={setConfirmar_exclusao}
                      onTrigger={() => {
                        setId_item_atual(uid ?? cod)
                        setNome_item_atual(microrganismo_nome)
                      }}
                      loading={fake_loading}
                      message={`o item ${microrganismo_nome} será excluido!`}
                      deleteds={[microrganismo_nome]}
                      onDelete={() => remover_microrganismos(uid, cod, cod_microrganismo)}
                      disabled={fake_loading}
                      // disabledTrigger={permissions?.exclusao === 0}
                      typeButtonTrigger='secondary'
                    />
                    <ButtonCustom
                      onClick={() =>
                        editarComposicao(
                          cod,
                          cod_microrganismo,
                          microrganismo_nome,
                          tipo_porcentagem,
                          tipo_porcentagem_nome,
                          porcentagem,
                          concentracao,
                          densidade,
                          cepa
                        )
                      }
                      icon={<FontAwesomeIcon icon={faPen} />}
                      disabled={cod === null}
                    />
                  </RowItem>
                </RowTable>
              )
            }
          )}
        </Render>

        <Render condition={loadingComposicao}>
          <Carregando animation legenda='Carregando...' size='small' justifyContent='center' height={300} />
        </Render>

        <Render condition={composicao_adicionada.length <= 0}>
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={<> Nenhum registro disponível!</>}
          />
        </Render>
      </BodyTable>
    </div>
  )
}
